import React from 'react';
import { Text, TextProps } from '../../Text';
import { useCustomComponent } from '@/hooks';

export interface OfflineMessageTitleTextProps extends TextProps {}

const TitleTextComponent: React.FC<OfflineMessageTitleTextProps> = props => {
  return <Text {...props} />;
};

export const TitleText: React.FC<OfflineMessageTitleTextProps> = (
  props: OfflineMessageTitleTextProps
) => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessageTitleText',
    Component: TitleTextComponent,
  });

  return <Component {...props} />;
};
